module.exports = __webpack_public_path__ + "static/media/arrow_2.d81fb18b.svg";